export default __webpack_public_path__ + "static/media/contact.779c52fe.jpg";